export default {
  PlanReceipt: {
    // Chương
    Chapter: 1,
    // Loại khoản
    KindItem: 2,
    // Nhóm mục chi
    GroupItem: 3,
    // Mục
    Item: 4,
    // Tiểu mục
    SubItem: 5,
    // Tiết
    DetailItem: 6,
  },
};
